import { IEnvironmentModel } from './environment.model';

export const stagingEnvironment: IEnvironmentModel = {
  type: 'staging',
  production: false,
  dev: false,
  domain: 'di.hrm.stag.visma.net',

  // logging
  enableBrowserLogs: true,
  enableRUM: false,

  // authentication and client IDs
  dummyAuth: false,
  signinUrl: 'https://signin.stag.visma.net/loginwebapp',
  loginRedirectUrl: 'https://di.hrm.stag.visma.net',
  oauth: {
    issuer: 'https://connect.identity.stagaws.visma.com',
    clientId: 'VismaNetHrmDataImport',
  },
  ldClientSideID: '608646e5acde0f0c15a5f561',
  wootricAccountToken: 'NPS-EU-2afb00ff',

  // APIs
  dataImportApiBaseUrl: 'https://api.di.hrm.stag.visma.net',
  staticJsonApiBaseUrl: 'https://static-json.no.stag.visma.net/',
  wsBaseUrl: 'wss://ws.di.hrm.stag.visma.net',

  // external links
  empManModuleId: 4742422,
  vismaHomeUrl: 'https://home.stag.visma.com/',
  vismaEmpmanUrl: 'https://web.employeecore1.hrm.stag.visma.net/uiempmanapp/',
  vismaAboutUrl: 'https://wagerun.cj.hrm.stag.visma.net/',
  vismaCalendarUrl: 'https://web.calendar.hrm.stag.visma.net/',
  payrollUiUrl: 'https://payrollui.no.stag.visma.net/',
  payrollPortal:
    'https://web.calendar.hrm.stag.visma.net/absence/_Svelte/dist/scripts/es/ClientPortalComponentProvider.js',
  wagerunUrl: 'https://wagerun.cj.hrm.stag.visma.net',
  accountSettingsUrl: 'https://accountsettings.connect.identity.stagaws.visma.com/',

  // embedded components
  timeDocumentsUrl:
    'https://ui.time.hrm.stag.visma.net/timeui/dist/clientportal-component-provider.js',
  variableTransactionsUrl:
    'https://wagerun.cj.hrm.stag.visma.net/componentProviders/employeeTransactionsProviderV1.js',
  assistant: {
    apiBaseUrl: 'https://api.assistant.stag.vsn.dev',
    profileId: 'payroll-prod',
  },
  walkmeSrc:
    'https://eu-cdn.walkme.com/users/156f0c8fa19a4b7cbd7437d888ce43cc/test/walkme_private_156f0c8fa19a4b7cbd7437d888ce43cc_https.js',
  walkmeIntegrity: 'sha256-xA7YXeCjh992RrqQgJYVJkaC1WKs0iPQ4lE/tNN65b4=',
};
